import { Utils } from "@/plugins/utils"
import router from "@/router"
import qs from "qs"
const scanErro = require("../../../public/audio/ScanErro.wav")

export default {
	namespaced: true,
	state: {
		lstPr0: [],
		pr0: null,
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false,
	},
	getters: {
		getPr0(state) {
			state.pr0.pr0fci = state.pr0.pr0fci == "" ? "00000000-0000-0000-0000-000000000000" : state.pr0.pr0fci
			state.pr0.lstCvf = []
			state.pr0.lstPr3 = []
			state.pr0.lstPr2 = []
			state.pr0.pr0largura = parseFloat(state.pr0?.pr0largura ?? 0)
			state.pr0.pr0altura = parseFloat(state.pr0?.pr0altura ?? 0)
			state.pr0.pr0comprim = parseFloat(state.pr0?.pr0comprim ?? 0)
			state.pr0.pr0pesoliq = parseFloat(state.pr0?.pr0pesoliq ?? 0)
			state.pr0.pr0pesobru = parseFloat(state.pr0?.pr0pesobru ?? 0)
			state.pr0.pr0pesoaca = parseFloat(state.pr0?.pr0pesoaca ?? 0)
			state.pr0.pr0fatortr = parseFloat(state.pr0?.pr0fatortr ?? 0)

			return state.pr0
		},
		getUpdate(state) {
			return state.update
		},
		getPr0produto(state) {
			return state.pr0.pr0produto
		},
		getSearch(state) {
			return state.search
		},
	},
	mutations: {
		set(state, pr0) {
			state.pr0 = pr0
			if (pr0) state.update = true
		},
		initForm(state) {
			state.insert = false
			state.update = false
			state.pr0 = null
		},
		setParamsDataTable(state, payload) {
			state.lstPr0 = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
		setPr0(state, pr0) {
			state.pr0 = pr0
		},
		setLoading(state, loading) {
			state.loading = loading
		},
		setSearch(state, search) {
			state.search = search
		},
		setLstPr0(state, lstPr0) {
			state.lstPr0 = lstPr0
		},
	},
	actions: {
		initForm({ commit }) {
			commit("initForm")
		},
		async get({ dispatch }, pr0produto) {
			return await this._vm.$axios
				.get(`/Products/Product/FindByPr0produto/${pr0produto}`)
				.then(response => {
					return Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return null
				})
		},
		async find({ commit, dispatch }, pr0produto) {
			commit("setLoading", true)
			commit("initForm")
			let payload = await dispatch("get", pr0produto)
				.then(pr0 => {
					commit("set", pr0)
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			commit("setLoading", false)
			return payload
		},
		async save({ dispatch, getters }) {
			if (getters.getUpdate) {
				return await dispatch("update")
			}
			return await dispatch("insert")
		},
		async insert({ dispatch, commit, getters }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true },
			)
			let payload = await this._vm.$axios
				.post("/Products/Product/Insert", getters.getPr0)
				.then(response => {
					commit("initForm")
					return Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return null
				})

			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async saveComplete({ dispatch, getters, commit }, { lstPr2, lstPr3, lstCvf }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true },
			)
			let pr0 = getters.getPr0
			pr0.lstPr2 = lstPr2
			pr0.lstPr3 = lstPr3
			pr0.lstCvf = lstCvf
			let forUpdate = getters.getUpdate

			let payload = await this._vm.$axios
				.post("/Products/Product/SaveComplete", pr0, { params: { forUpdate } })
				.then(response => {
					let pr0Saved = Utils.ValidateAxiosResponse(response.data)
					commit("initForm")
					return pr0Saved
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return null
				})

			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async update({ dispatch, getters, commit }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true },
			)
			let payload = await this._vm.$axios
				.put("/Products/Product/Update", getters.getPr0)
				.then(response => {
					commit("initForm")
					return Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async delete({ dispatch, getters }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Excluindo", indeterminate: true },
				{ root: true },
			)
			await this._vm.$axios
				.delete(`/Products/Product/Delete/${getters.getPr0produto}`)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					router.push("/oryxpdv/produtos")
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
		async search({ commit, dispatch, getters }, { limit = 20, page = 1 }) {
			commit("setLoading", true)
			commit("initForm")
			await this._vm.$axios
				.get(`/Products/Product/Search?search=${getters.getSearch}&limit=${limit}&page=${page}`)
				.then(response => {
					let payload = Utils.ValidateAxiosResponse(response.data)
					commit("setParamsDataTable", payload)
				})
				.catch(error => {
					commit("setLstPr0", [])
					commit("setSearch", "")
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
				})
			commit("setLoading", false)
		},
		async advancedSearch({ commit, dispatch, getters }, { limit = 20, page = 1, searchQueryParams }) {
			const queryParams = {
				limit,
				page,
				search: getters.getSearch,
				...searchQueryParams,
			}
			commit("setLoading", true)
			commit("initForm")
			await this._vm.$axios
				.get("/Products/Product/Search", { params: queryParams })
				.then(response => {
					let payload = Utils.ValidateAxiosResponse(response.data)
					commit("setParamsDataTable", payload)
				})
				.catch(error => {
					commit("setLstPr0", [])
					commit("setSearch", "")
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
				})
			commit("setLoading", false)
		},
		async getPrice(
			{ dispatch },
			{ pr0produto, lista, cpfCnpj = "", pr3tamanho = "", defaultPrice = false, pr2opcao = "" },
		) {
			return await this._vm.$axios
				.get(
					`/Price/Price/PriceHierarchy/${pr0produto}/${lista}/${pr3tamanho}/${pr2opcao}?precopadrao=${defaultPrice}&cpfCnpj=${cpfCnpj}`,
				)
				.then(response => {
					return Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return 0
				})
		},
		async findCartByCode(
			{ dispatch },
			{ product, list, volume, pedido, lstVd8, silent, cpfCnpj, prontaEntrega, onlyForRead = false },
		) {
			if (!silent)
				dispatch(
					"parameters/openGlobalLoading",
					{ showLoadingGlobal: true, text: "Consultando produto", indeterminate: true },
					{ root: true },
				)
			let payload = await this._vm.$axios
				.post("/Products/Product/FindByCode/", {
					product,
					list,
					volume,
					pedido,
					lstVd8,
					cpfCnpj,
					prontaEntrega,
					onlyForRead,
				})
				.then(response => {
					let productCartModel = Utils.ValidateAxiosResponse(response.data)
					return {
						pr0imagem: productCartModel.pr0imagem,
						vdvpeca: productCartModel.eancodigo,
						vd8peca: productCartModel.of3peca,
						pr0produto: productCartModel.pr0produto,
						pr0desc: productCartModel.pr0desc,
						pr2opcao: productCartModel.pr2opcao,
						pr3tamanho: productCartModel.pr3tamanho,
						vd5preco: productCartModel.vd5preco,
						vd3qtde: 0,
						of3naoconf: productCartModel.of3naoconf,
						confIndis: productCartModel.confIndis,
						of3rfid: productCartModel.of3rfid,
						cr1nome: productCartModel.cr1nome,
						pr0pesobru: productCartModel.pr0pesobru,
						pr0pesoliq: productCartModel.pr0pesoliq,
						pr0largura: productCartModel.pr0largura,
						pr0altura: productCartModel.pr0altura,
						pr0comprim: productCartModel.pr0comprim,
						stock: productCartModel.stock,
						discount: 0,
						changePricePr0: false,
						valueWithDiscount: productCartModel.vd5preco,
						vdvdescont: 0,
						vd8descont: 0,
					}
				})
				.catch(error => {
					var audio = new Audio(scanErro)
					if (!silent) audio.play()
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return null
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async findCart({ dispatch }, { product, list, cpfCnpj = "" }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Consultando produto", indeterminate: true },
				{ root: true },
			)
			let payload = await this._vm.$axios
				.get(`/Products/Product/Find/${product}/${list}?cpfCnpj=${cpfCnpj}`)
				.then(response => {
					return Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return null
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async findEan({ dispatch }, { pr0produto, pr2opcao = "", pr3tamanho = "" }) {
			dispatch(
				"parameters/openGlobalLoading",
				{
					showLoadingGlobal: true,
					text: "Consultando produto",
					indeterminate: true,
				},
				{ root: true },
			)
			let payload = await this._vm.$axios
				.get(`/Products/Product/FindEan?pr0produto=${pr0produto}&pr2opcao=${pr2opcao}&pr3tamanho=${pr3tamanho}`)
				.then(response => {
					return Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return ""
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async findReturnByCode(
			{ dispatch, rootGetters, rootState },
			{
				product,
				lstItems,
				qty,
				isSales,
				input = false,
				silent = false,
				price = 0,
				option = "",
				size = "",
				managerApproval = false,
				revalidate = false,
			},
		) {
			var audio = new Audio(scanErro)
			let lxd = rootGetters["lxd/getLxd"]
			let cf1cliente = rootGetters["vdk/getVdkcliente"]
			let tabVdItem = rootGetters["vdk/getTabVdItem"]

			if (isSales && tabVdItem > 0) {
				cf1cliente = rootGetters["vdk/getVdkclienteByTabVdItem"]
			}

			lstItems = JSON.parse(JSON.stringify(lstItems))
			for (const vditem of lstItems) {
				vditem.eancodigo = vditem.vdxpeca
				vditem.of3peca = vditem.vdlpeca
			}

			if (!silent)
				dispatch(
					"parameters/openGlobalLoading",
					{ showLoadingGlobal: true, text: "Consultando produto", indeterminate: true },
					{ root: true },
				)
			let payload = await this._vm.$axios
				.post("/Products/Product/FindReturnByCode/", {
					product,
					option,
					size,
					lstItems,
					cf1cliente,
					consigned: rootGetters["vdk/getConsigned"],
					qty,
					input,
					managerApproval,
				})
				.then(async response => {
					let productReturnModel = Utils.ValidateAxiosResponse(response.data)
					if (productReturnModel.isError) {
						if (!revalidate) {
							if (rootGetters["vdk/getManagerApproval"]) {
								dispatch("findReturnByCode", {
									product,
									option,
									size,
									lstItems,
									qty,
									isSales: false,
									input,
									managerApproval: true,
									silent: true,
								}).then(payloadProduct => {
									if (payloadProduct) {
										payloadProduct.qtde = qty
										payloadProduct.vdxqtdeent = 0

										dispatch(
											"vdk/addVdItem",
											{ pr0: payloadProduct, prefix: lxd.lxdean ? "vdx" : "vdl" },
											{ root: true },
										)
										if (isSales) {
											dispatch("vd1/calculatevd1vltroca", null, { root: true }).then(
												dispatch("vd1/calculateDiscount", null, { root: true }).then(
													dispatch("vd1/calculateCv8", {}, { root: true }),
												),
											)
										}
									}
								})
							} else {
								if (!silent) audio.play()

								dispatch(
									"parameters/openDialog",
									{
										titleText: "Erro",
										titleColor: "red",
										text: productReturnModel.messageError,
										confirmBtn: true,
										confirmText: "Ok",
										cancelText: "Autorizar",
										cancelAction: () => {
											dispatch(
												"parameters/openManagerDialog",
												{
													showCheckBox: true,
													textCheckBox: "Aplicar para as próximas leituras",
													confirmAction: () => {
														dispatch(
															"vdk/setManagerApproval",
															rootGetters["parameters/getDialogManagerCheckBoxValue"],
															{ root: true },
														)
														dispatch("findReturnByCode", {
															product,
															option,
															size,
															lstItems,
															qty,
															isSales,
															input,
															managerApproval: true,
														}).then(payloadProduct => {
															if (payloadProduct) {
																payloadProduct.qtde = qty
																payloadProduct.vdxqtdeent = 0

																dispatch(
																	"vdk/addVdItem",
																	{ pr0: payloadProduct, prefix: lxd.lxdean ? "vdx" : "vdl" },
																	{ root: true },
																)
																if (isSales) {
																	dispatch("vd1/calculatevd1vltroca", null, { root: true }).then(
																		dispatch("vd1/calculateDiscount", null, { root: true }).then(
																			dispatch("vd1/calculateCv8", {}, { root: true }),
																		),
																	)
																}
															}
														})
													},
													dc0arquivo: "VDK",
													permission: "DC5ESPECIA",
												},
												{ root: true },
											)
										},
									},
									{ root: true },
								)
							}
						}

						return null
					}
					if (tabVdItem == 0) {
						let hadClientInformed = false
						if(rootState.vd1.vd1.vd1cliente)
							hadClientInformed = true

						dispatch(
							"vdk/setHeaderInfos",
							{
								vdkcliente: productReturnModel.cf1cliente,
								isSales,
								vd1repres: productReturnModel.vd1repres,
							},
							{ root: true },
						)
						
						if(isSales && !hadClientInformed) {
							await dispatch("fnl/findByCustomer", productReturnModel.cf1cliente, {root: true})
							.then(async (lstFnl) => {
								if (lstFnl) {
									let fnlcredito = lstFnl.reduce((accumulator, f) => accumulator + f.fnlcredito, 0);
									rootState.vd1.customerOldCredit = fnlcredito
									rootState.vd1.lstVd7[0].customerOldCredit = fnlcredito
									await dispatch("vd1/calculatevd1vltroca", null, { root: true })
									dispatch("vd1/calculateCv8", {}, { root: true })
								}
							})
						}
					}
					return {
						pr0imagem: productReturnModel.pr0imagem,
						vdxpeca: productReturnModel.eancodigo,
						vdlpeca: productReturnModel.of3peca,
						pr0produto: productReturnModel.pr0produto,
						pr0desc: productReturnModel.pr0desc,
						pr2opcao: productReturnModel.pr2opcao,
						pr3tamanho: productReturnModel.pr3tamanho,
						preco: productReturnModel.preco,
						qtde: 0,
						doc: productReturnModel.doc,
						volume: productReturnModel.volume,
						descon: productReturnModel.descon,
						precodesc: productReturnModel.precodesc,
						taxes: productReturnModel.taxes,
						vdedoc: productReturnModel.vdedoc,
						vdxqtdeent: productReturnModel.vdxqtdeent,
						consigned: productReturnModel.consigned,
						rfid: productReturnModel.of3rfid,
						cr1nome: productReturnModel.cr1nome,
						emissao: productReturnModel.emissao,
						cv5emissao: productReturnModel.cv5emissao,
						precoOriginal: productReturnModel.precoOriginal,
						managerApproval: productReturnModel.managerApproval,
						modeloFiscal: productReturnModel.modeloFiscal,
						discountBeforeConsignment: productReturnModel.originalDiscount,
						cv7itemrefe: productReturnModel.cv7itemrefe
					}
				})
				.catch(error => {
					let text = error.message
					if (!silent) audio.play()
					else text += "<br />Peça: " + product

					if (!revalidate) {
						dispatch(
							"parameters/openDialog",
							{
								titleText: "Erro",
								titleColor: "red",
								text,
								confirmBtn: lxd.lxdentrdev && lxd.lxdean && (lxd.lxdmoddev || !rootGetters["vdk/getConsigned"]),
								confirmText:
									lxd.lxdentrdev && lxd.lxdean && (lxd.lxdmoddev || !rootGetters["vdk/getConsigned"]) ? "Ok" : null,
								cancelText:
									lxd.lxdentrdev && lxd.lxdean && (lxd.lxdmoddev || !rootGetters["vdk/getConsigned"])
										? "Entrada"
										: "Ok",
								cancelAction: () => {
									if (lxd.lxdentrdev && lxd.lxdean && (lxd.lxdmoddev || !rootGetters["vdk/getConsigned"])) {
										dispatch("findReturnByCode", {
											product,
											option,
											size,
											lstItems,
											qty,
											isSales: false,
											input: true,
											managerApproval,
										}).then(payloadProduct => {
											if (payloadProduct) {
												if (price) payloadProduct.preco = price

												payloadProduct.qtde = qty
												payloadProduct.vdxqtdeent = qty
												payloadProduct.precodesc = payloadProduct.preco
												payloadProduct.total = parseFloat((payloadProduct.preco).toFixed(2) * payloadProduct.qtde)

												dispatch(
													"vdk/addVdItem",
													{ pr0: payloadProduct, prefix: lxd.lxdean ? "vdx" : "vdl" },
													{ root: true },
												)
												if (isSales) {
													dispatch("vd1/calculatevd1vltroca", null, { root: true }).then(
														dispatch("vd1/calculateDiscount", null, { root: true }).then(
															dispatch("vd1/calculateCv8", {}, { root: true }),
														),
													)
												}
											}
										})
									}
								},
							},
							{ root: true },
						)
					}

					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async readingRfid({ dispatch }, { lstSalesItems = null, lstReturnItems = null }) {
			let url = "/Products/Rfid/FindBySales"
			if (lstSalesItems == null) url = "/Products/Rfid/FindByReturn"
			let payload = await this._vm.$axios
				.post(url, {
					lstSalesItems,
					lstReturnItems,
				})
				.then(response => {
					return Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return []
				})
			return payload
		},
		async findForProductSearch({ dispatch }, { text, orderBy }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Consultando dados", indeterminate: true },
				{ root: true },
			)

			let payload = await this._vm.$axios
				.get(`/Products/Product/FindForProductSearch?text=${text}&orderBy=${orderBy}`)
				.then(response => {
					return Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return []
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async productSearch({ dispatch }, productSearchRequestModel) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Consultando dados", indeterminate: true },
				{ root: true },
			)

			let payload = await this._vm.$axios
				.get(`/Products/ProductSearch/Find`, {
					params: productSearchRequestModel,
					paramsSerializer: params => {
						return qs.stringify(params)
					},
				})
				.then(response => {
					return Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return []
				})

			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async readingRfidFind({ dispatch }) {
			let payload = await this._vm.$axios
				.get("/Products/Rfid/Find")
				.then(response => {
					return Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return []
				})
			return payload
		},
		async savePr0Image({ dispatch }, { pr0produto, image }) {
			const formData = new FormData()
			formData.append("image", image)

			let payload = await this._vm.$axios
				.post("/Products/Image/Save/PR0/" + pr0produto, formData, {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				})
				.then(response => {
					return Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{ titleText: "Erro", titleColor: "red", text: error.message },
						{ root: true },
					)
					return null
				})
			return payload
		},
		async deletePr0Image({ dispatch }, pr0produto) {
			let payload = await this._vm.$axios
				.delete("/Products/Image/Delete/PR0/" + pr0produto)
				.then(response => {
					return Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{ titleText: "Erro", titleColor: "red", text: error.message },
						{ root: true },
					)
					return null
				})
			return payload
		},
		async verifyPr0Exist({ _ }, pr0produto) {
			let payload = await this._vm.$axios
				.get("/Products/Product/FindByPr0produto/" + pr0produto)
				.then(response => {
					return Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					return null
				})
			return payload
		},
	},
}
